import React, { useState, useEffect } from "react"
import { SearchOutlined } from "@ant-design/icons"
import { useNavigate, useSearchParams } from "react-router-dom"
import { Input, message, Empty } from "antd"
import { useSnapshot } from "valtio"
import { DeleteOutlined } from "@ant-design/icons"
import historyStore, { addHistory, removeHistory } from "@/store/history"
import useClickOutside from "@/hooks/useOutClick"
import styles from "./css/header.modules.less"

const Header = () => {
  const [value, setValue] = useState("")
  const [historyFlag, setHistoryFlag] = useState(false)
  const [messageApi, content] = message.useMessage()
  const [search] = useSearchParams()
  const navigate = useNavigate()

  const { historyList } = useSnapshot(historyStore)

  useEffect(() => {
    document.addEventListener("click", domOutClickBtn)
    const str = search.get("value")
    str && setValue(str)
    return () => {
      document.removeEventListener("click", domOutClickBtn)
    }
  }, [])
  // 搜索
  const searchCallback = (val) => {
    if (!val) {
      messageApi.open({
        type: "warning",
        content: "请输入搜索内容"
      })
      return
    }
    addHistory(val)
    setHistoryFlag(false)
    navigate(`/searchDetail?value=${val}`)
  }
  // 点击记录
  const clickHistory = (val) => {
    setValue(val)
    searchCallback(val)
  }
  // 删除记录
  const removeItem = (e, val) => {
    e.stopPropagation()
    removeHistory(val)
  }
  // dom外点击（PS：document监听的事件获取不到createRef定义的dom）
  const domOutClickBtn = (e) => {
    const searchBtn = document.querySelector(".search-btn")
    const historyBox = document.querySelector(".history-box")
    if (!historyBox) return
    // 点击播放列表的icon也是相当于内部点击
    if (!searchBtn.contains(e.target) && !historyBox.contains(e.target)) {
      setHistoryFlag(false)
    } else {
      setHistoryFlag(true)
    }
  }
  return (
    <div className={styles.headerBox}>
      {content}
      <Input
        allowClear
        value={value}
        prefix={<SearchOutlined />}
        className="search-btn"
        placeholder="请输入单曲/歌手/专辑/MV/歌单等关键字"
        onChange={(e) => setValue(e.target.value)}
        onPressEnter={() => searchCallback(value)}
        onFocus={() => setHistoryFlag(true)}
      />
      {historyFlag && (
        <ul className="history-box scrollY">
          {historyList.length ? (
            <>
              {historyList.map((item) => (
                // 此处用按下事件是因为blur事件优先级高于click
                <li key={item} onMouseDown={() => clickHistory(item)}>
                  <span>{item}</span>
                  <DeleteOutlined
                    title="删除"
                    onMouseDown={(e) => removeItem(e, item)}
                  />
                </li>
              ))}
            </>
          ) : (
            <Empty className="empty" />
          )}
        </ul>
      )}
    </div>
  )
}

export default Header
